require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-nicola-navone-una-casa-fortezza-nella-fungaia-dei-villini-casa-paul-e-marthe-ruchat-a-morbio-inferiore-mendrisio-28-novembre-2018.json") })
        }
      }, "path---relazioni-e-conferenze-nicola-navone-una-casa-fortezza-nella-fungaia-dei-villini-casa-paul-e-marthe-ruchat-a-morbio-inferiore-mendrisio-28-novembre-2018");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-nicola-navone-una-casa-fortezza-nella-fungaia-dei-villini-casa-paul-e-marthe-ruchat-a-morbio-inferiore-mendrisio-28-novembre-2018!./.cache/json/relazioni-e-conferenze-nicola-navone-una-casa-fortezza-nella-fungaia-dei-villini-casa-paul-e-marthe-ruchat-a-morbio-inferiore-mendrisio-28-novembre-2018.json
// module id = 738
// module chunks = 231608221292675